import { BaseOnePageMicrosoftModel } from '../../../../../orchestration/microsoft/reports/models/base-one-page-microsoft-model';
import { FileShareReportProfile } from '../../../../../models/microsoft/fileshare/profile/file-share-report-profile';
import { ReportProfileRulesComputedDelegate } from '../../../../../models/profile/report-profile-rules-computed-delegate';

export class FileShareOnePageModel extends BaseOnePageMicrosoftModel {
  resourceProfile: FileShareReportProfile;
}
